import { FC } from 'react';
import { ProfileMenuView } from './ProfileMenu';
import { useMenuItems } from './useMenuItems';

export const ProfileMenuContainer: FC = () => {
  const { title, menuItems } = useMenuItems();
  return <ProfileMenuView name={title} menu={menuItems} />;
};
